module.exports = __webpack_public_path__ + "static/media/bgcolor.bc6177fe.png";